// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const checkmarkClasses = {
  icon: "qui-checkmark__icon",
  root: "qui-checkmark__root",
} as const
